import store from '@/store';
import i18n from '../i18n';
import { localisationConstants } from 'pando-constants';

export default async function setLocale(language) {
  const locale = localStorage.getItem('tsm-shipper-locale') || language;
  i18n.setLocaleMessage(locale, localisationConstants);
  i18n.locale = locale;
  const localeData = await store.dispatch('app/getLocales', locale);
  if (localeData) {
    i18n.setLocaleMessage(locale, { ...localisationConstants, ...localeData });
  }
}
